import { jsx as _jsx } from "react/jsx-runtime";
import { escapeRegExp } from 'lodash';
export var Highlighted = function (_a) {
    var text = _a.text, highlight = _a.highlight;
    if (!(highlight === null || highlight === void 0 ? void 0 : highlight.trim())) {
        return _jsx("span", { children: text });
    }
    var regex = new RegExp("(".concat(escapeRegExp(highlight), ")"), 'gi');
    var parts = text.split(regex);
    return (_jsx("span", { children: parts
            .filter(function (part) { return part; })
            .map(function (part, index) {
            // eslint-disable-next-line react/no-array-index-key
            return regex.test(part) ? _jsx("mark", { children: part }, index) : _jsx("span", { children: part }, index);
        }) }));
};
